<div class="row">
  <div class="col-12 voter-list">
    <div [hidden]="loading">
      <h5 class="text-primary">
        {{ results.length }} of {{ totalCount }} voters
      </h5>
      <voter-preview
        style="margin: 0px; padding: 0px"
        *ngFor="let vote of results"
        [vote]="vote"
        [query]="query"
        class="col-md-4"
        (setTagTo)="setTagTo($event)"
      >
      </voter-preview>
    </div>

    <!-- Loader spinner -->
    <loader-animation [loading]="loading" [message]="'Loading profiles'">
    </loader-animation>
    <!-- Loader spinner -->

    <!-- No content message-->
    <no-content-msg
      [hidden]="loading || results.length"
      [message]="'No profiles here... yet'"
    >
    </no-content-msg>
    <!-- No content message -->

    <!-- Pagination -->
    <pagination-buttons
      [currentPage]="currentPage"
      [loading]="loading"
      [showNavBar]="false"
      [smallButtons]="false"
      [totalPageCount]="totalPages"
      (setPageTo)="setPageTo($event)"
    >
    </pagination-buttons>
    <!-- Pagination -->
  </div>
</div>
